jQuery(function($){
    initAjaxBtn();
    initVideos();
    function initAjaxBtn() {
        $('#ajax-btn-europe').off('click');
        $('#ajax-btn-europe').on('click', function(e){
            e.preventDefault();

            var body = $('body');
            var offset = false;
            var postType = '';
            if (body.hasClass('page-template-videos')) {
                var action = 'loadmoreVideos';
                postType = 'video';
            }
            
            var button = $(this),
                data = {
                'action': action,
                'query': loadmore_params.posts,
                'page': loadmore_params.current_page,
                'offset': offset,
                'post_type': postType
            };

            $.ajax({
                url: loadmore_params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function ( xhr ) {
                    button.addClass('is-loading');
                },
                success: function( data ){
                    if(data.replace(/\s/g, '').length) { 
                        button.removeClass('is-loading').closest('div').prev().after(data);
                        loadmore_params.current_page++;

                        if ( loadmore_params.current_page == loadmore_params.max_page ) 
                            button.remove();
                    } else {
                        button.remove();
                    }
                }
            });
        });
    }
    //Initialisation MagnificPopup
    function initVideos() {
        var videos = $('.bloc-videos .video');

        videos.find('.play').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160, 
            preloader: false,
            fixedContentPos: true,
            overflowY: 'hidden'
        });
    }
    if($('body').hasClass('page-template-videos')){
        
        function loadAjaxVideos(data, url){
			$.ajax({
				url: ajaxurl,
				data: data, 
				type: 'GET',
				beforeSend: function ( xhr ) {
					$('#post-container').remove();
					$('#onload').removeClass('d-none');
				},
				success: function( data ){
					if( data ) {
                        $('#onload').addClass('d-none');
						$('#ajax-container').html(data);
                        initAjaxBtn();
                        
                        console.log(url);
                        if (url != null) {                            
                            window.history.pushState('', '', url);
                        }
                        
                        //Clic sur les tris
                        $('.header-sort .tri').click(function(){
                           $(this).toggleClass('active');
                           if($(this).hasClass('active')){
                               $(this).text($(this).attr('attr-asc'));
                               $('form.filters input[name="tri"]').attr('value','asc');
                           }else{
                               $(this).text($(this).attr('attr-desc'));
                               $('form.filters input[name="tri"]').attr('value','desc');
                           }
                           $('form.filters').trigger('submit');
                        });

                        initVideos();
					}
				}
			});
		}
        
        //Clic sur les tris
        $('.header-sort .tri').click(function(){
           $(this).toggleClass('active');
           if($(this).hasClass('active')){
               $(this).text($(this).attr('attr-asc'));
               $('form.filters input[name="tri"]').attr('value','asc');
           }else{
               $(this).text($(this).attr('attr-desc'));
               $('form.filters input[name="tri"]').attr('value','desc');
           }
           $('form.filters-videos').trigger('submit');
        });
        
        $('form.filters-videos').submit(function(event){
			event.preventDefault();
            var motClef = $('form.filters input[name="mot-clef"]').val();
            if (motClef == null) {
                motClef = '';
            }
            var tri = $('form.filters input[name="tri"]').val();
                        
            var url = $(this)[0]['action'].split('?')[0].split('page/')[0]+'?mot-clef='+motClef;
            
            var params = [];            
            var paramsArray = setParamsVideos(params, motClef, tri, url);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);

            var data = {
				'action': 'loadVideos',
				'mot-clef':motClef,
				'tri':tri,
                'link': link
            };
            loadAjaxVideos(data, url);
		});
        
        // pagination
        $(document).on('click','.page-numbers li a',function(e){
			e.preventDefault();
			
			var paged = $(this).attr('data-page');
            
            var motClef = $('form.filters input[name="mot-clef"]').val();
            if (motClef == null) {
                motClef = '';
            }

            var url = $(this).attr('href');
            var tri = $('form.filters input[name="tri"]').val();
            
            var params = [];            
            var paramsArray = setParamsVideos(params, motClef, tri, url);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
            var data = {
				'action': 'loadVideos',
				'paged': paged,
                'mot-clef':$('form.filters input[name="mot-clef"]').val(),
				'tri': tri,
                'link': link
            };
            
            loadAjaxVideos(data, url);
		});
        
        // mobile
        var paged=1;
		$(document).on('click','.loadmore',function(e){
			e.preventDefault();
			var data = {
				'action': 'loadVideos',
				'mot-clef':$('form.filters input[name="mot-clef"]').val(),
                'tri': $('form.filters input[name="tri"]').val(),
				'paged': ++paged
				},
				button = $(this),
				container = $('body main .section-results>.row');
				
			$.ajax({
				url: ajaxurl,
				data: data, 
				type: 'GET',
				beforeSend: function ( xhr ) {
					button.addClass('is-loading');
					
				},
				success: function( data ){
					if( data ) {
						button.removeClass('is-loading');
						data = $(data).find('.teaser');
						if(data.length>0){
							$('<div class="content" tabindex="-1">').insertAfter(container.find('.content').last());
							container.find('.content').last().append(data);
						}else{
							button.remove();
						}
					} else {
						button.remove();
					}
				}
			});
		});
        
        function setParamsVideos(params, motClef, tri, url) {
            if (motClef != null && motClef.length) {
                params.push({
                    'name': 'mot-clef',
                    'value': motClef
                })
            }
            if (tri != null && tri.length) {
                url += '&tri='+tri;

                params.push({
                    'name': 'tri',
                    'value': tri
                })
            }
            
            return [url, params];
        }
    }
    
    if($('body').hasClass('page-template-projets')){
		
		function loadAjaxprojets(data,container, url){
			$.ajax({
				url: ajaxurl,
				data: data, 
				type: 'GET',
				beforeSend: function ( xhr ) {
					container.find('.results').slideUp(700,function(){
						$(this).remove();
					}).fadeOut();
					container.find('.header-results .onload').removeClass('d-none');
					$('form.filters button').addClass('is-loading');
					
				},
				success: function( data ){
					if( data ) {
						$('form.filters button').removeClass('is-loading');
						container.find('.results').remove();//On est sur que d'autres résultats ne sont pas présents
						container.append(data);
						$('html, body').animate({
		                    scrollTop: $(".section-results").offset().top - 120 
			              }, 500);
						container.find('.results').slideUp(0).slideDown(2000);
						container.find('.header-results .onload').addClass('d-none');
						container.find('.header-results .nb_results').html(container.find('.results').attr('data-nb-reults'));
                        
                        if (url != null) {                            
                            window.history.pushState('', '', url);
                        }
					} else {
						//button.remove();
					}
				}
			});
		}
        function setParamsProjets(params, tri, url, motClef, thematique, fond, departement) {
            if (motClef != null && motClef.length) {
                params.push({
                    'name': 'mot-clef',
                    'value': motClef
                })
            }
            if (thematique != null && thematique.length) {
                url += '&thematique='+thematique;
                
                params.push({
                    'name': 'thematique',
                    'value': thematique
                })
            }
            if (fond != null && fond.length) {
                url += '&fond='+fond;
                
                params.push({
                    'name': 'fond',
                    'value': fond
                })
            }
            if (departement != null && departement.length) {
                url += '&departement='+departement;
                
                params.push({
                    'name': 'departement',
                    'value': departement
                })
            }
            if (tri != null && tri.length) {
                url += '&tri='+tri;
                
                params.push({
                    'name': 'tri',
                    'value': tri
                })
            }
            return [url, params];
        }
        
		$('form.filters').submit(function(event){
			event.preventDefault();
            
            var motClef = $('form.filters input[name="mot-clef"]').val();
			var thematique = $('form.filters select[name="thematique"]').val();
			var fond = $('form.filters select[name="fond"]').val();
			var departement = $('form.filters select[name="departement"]').val();
			var tri = $('form.filters input[name="tri"]').val();
            
            var url = $(this)[0]['action'].split('?')[0].split('page/')[0]+'?mot-clef='+motClef;

            var params = [];            
            var paramsArray = setParamsProjets(params, tri, url, motClef, thematique, fond, departement);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
			var data = {
				'action': 'loadProjets',
				'mot-clef': motClef,
				'thematique': thematique,
				'fond': fond,
				'departement': departement,
				'tri': tri,
                'link': link
				},
				container = $('body main .section-results>.row'); 
				loadAjaxprojets(data,container, url);
		});
        
        
        //Clic sur les tris
        $('.header-sort .tri').click(function(){
           $(this).toggleClass('active');
           if($(this).hasClass('active')){
               $(this).text($(this).attr('attr-asc'));
               $('form.filters input[name="tri"]').attr('value','asc');
           }else{
               $(this).text($(this).attr('attr-desc'));
               $('form.filters input[name="tri"]').attr('value','desc');
           }
           $('form.filters').trigger('submit');
        });
		
		$(document).on('click','.page-numbers li a',function(e){
			e.preventDefault();
            
            var motClef = $('form.filters input[name="mot-clef"]').val();
			var thematique = $('form.filters select[name="thematique"]').val();
			var fond = $('form.filters select[name="fond"]').val();
			var departement = $('form.filters select[name="departement"]').val();
			var tri = $('form.filters input[name="tri"]').val();
            
			var paged = $(this).attr('data-page');
            var url = $(this).attr('href').split('?')[0]+'?mot-clef='+motClef;
            
            var params = [];            
            var paramsArray = setParamsProjets(params, motClef, thematique, fond, departement, tri, url);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
			var data = {
				'action': 'loadProjets',
				'mot-clef': motClef,
				'thematique': thematique,
				'fond': fond,
				'departement': departement,
				'tri': tri,
				'paged': paged,
                'link': link
				},
				container = $('body main .section-results>.row');
				loadAjaxprojets(data,container, url);
		});
		
		var paged=1;
		$(document).on('click','.loadmore',function(e){ 
			e.preventDefault();
			var data = {
				'action': 'loadProjets',
				'mot-clef':$('form.filters input[name="mot-clef"]').val(),
				'thematique':$('form.filters select[name="thematique"]').val(),
				'fond':$('form.filters select[name="fond"]').val(),
				'departement':$('form.filters select[name="departement"]').val(),
				'tri':$('form.filters input[name="tri"]').val(),
				'paged': ++paged
				},
				button = $(this),
				container = $('body main .section-results>.row');
				
			$.ajax({
				url: ajaxurl,
				data: data, 
				type: 'GET',
				beforeSend: function ( xhr ) {
					button.addClass('is-loading');
					
				},
				success: function( data ){
					if( data ) {
						button.removeClass('is-loading');
						data = $(data).find('.teaser');
						if(data.length>0){
							$('<div class="content" tabindex="-1">').insertAfter(container.find('.content').last());
							container.find('.content').last().append(data);
						}else{
							button.remove();
						}
					} else {
						button.remove();
					}
				}
			});
		});
	}

    if($('body').hasClass('page-template-documents')){
        console.log('rrr')
        function loadAjaxDocuments(data,container, url){
            $.ajax({
                url: ajaxurl,
                data: data, 
                type: 'GET',
                beforeSend: function ( xhr ) {
                    container.find('.results').slideUp(700,function(){
                        $(this).remove();
                    }).fadeOut();
                    container.find('.header-results .onload').removeClass('d-none');
                    $('form.filters button').addClass('is-loading');
                    
                },
                success: function( data ){
                    if( data ) {
                        $('form.filters button').removeClass('is-loading');
                        container.find('.results').remove();//On est sur que d'autres résultats ne sont pas présents
                        container.append(data);
                        $('html, body').animate({
                            scrollTop: $("main>.section-results").offset().top - 120 
                          }, 500);
                        container.find('.results').slideUp(0).slideDown(2000);
                        container.find('.header-results .onload').addClass('d-none');
                        container.find('.header-results .nb_results').html(container.find('.results').attr('data-nb-reults'));
                        
                        if (url != null) {                            
                            window.history.pushState('', '', url);
                        }
                    }
                }
            });
        }
        function setParamsDocuments(params, tri, url, motClef, typeDoc, fonds_concerne, date_de_parution, auteurs_doc) {
            if (motClef != null && motClef.length) {
                params.push({
                    'name': 'mot-clef',
                    'value': motClef
                })
            }
            if (typeDoc != null && typeDoc.length) {
                url += '&type-de-doc='+typeDoc;
                
                params.push({
                    'name': 'type-de-doc',
                    'value': typeDoc
                })
            }
            if (fonds_concerne != null && fonds_concerne.length) {
                url += '&fonds_concerne='+fonds_concerne;
                
                params.push({
                    'name': 'fonds_concerne',
                    'value': fonds_concerne
                })
            }
            if (date_de_parution != null && date_de_parution.length) {
                url += '&date_de_parution='+date_de_parution;
                
                params.push({
                    'name': 'date_de_parution',
                    'value': date_de_parution
                })
            }
            if (auteurs_doc != null && auteurs_doc.length) {
                url += '&auteurs_doc='+auteurs_doc;
                
                params.push({
                    'name': 'auteurs_doc',
                    'value': auteurs_doc
                })
            }
            if (tri != null && tri.length) {
                url += '&tri='+tri;
                
                params.push({
                    'name': 'tri',
                    'value': tri
                })
            }
            return [url, params];
        }
        
        $('form.filters').submit(function(event){
            event.preventDefault();
            
            var motClef = $('form.filters input[name="mot-clef"]').val();
            var type = $('form.filters input[name="type"]').val();
            var typeDoc = $('form.filters select[name="type-de-doc"]').val();
            var fonds_concerne = $('form.filters select[name="fonds_concerne"]').val();
            var date_de_parution = $('form.filters select[name="date_de_parution"]').val();
            var auteurs_doc = $('form.filters select[name="auteurs_doc"]').val();
            var tri = $('form.filters input[name="tri"]').val();
            
            var url = $(this)[0]['action'].split('?')[0].split('page/')[0]+'?mot-clef='+motClef;

            var params = [];            
            var paramsArray = setParamsDocuments(params, tri, url, motClef, typeDoc, fonds_concerne, date_de_parution, auteurs_doc);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
            var data = {
                'action': 'loadDocuments',
                'mot-clef': motClef,
                'type': type,
                'type-de-doc': typeDoc,
                'fonds_concerne': fonds_concerne,
                'date_de_parution': date_de_parution,
                'auteurs_doc': auteurs_doc,
                'tri': tri,
                'link': link
                },
                container = $('body main .section-results>.row'); 
                loadAjaxDocuments(data,container, url);
        });
        
        
        //Clic sur les tris
        $('.header-sort .tri').click(function(){
           $(this).toggleClass('active');
           if($(this).hasClass('active')){
               $(this).text($(this).attr('attr-asc'));
               $('form.filters input[name="tri"]').attr('value','asc');
           }else{
               $(this).text($(this).attr('attr-desc'));
               $('form.filters input[name="tri"]').attr('value','desc');
           }
           $('form.filters').trigger('submit');
        });
        
        $(document).on('click','.page-numbers li a',function(e){
            e.preventDefault();
            
            var motClef = $('form.filters input[name="mot-clef"]').val();
            var type = $('form.filters input[name="type"]').val();
            var typeDoc = $('form.filters select[name="type-de-doc"]').val();
            var fonds_concerne = $('form.filters select[name="fonds_concerne"]').val();
            var date_de_parution = $('form.filters select[name="date_de_parution"]').val();
            var auteurs_doc = $('form.filters select[name="auteurs_doc"]').val();
            var tri = $('form.filters input[name="tri"]').val();
            
            var paged = $(this).attr('data-page');
            var url = $(this).attr('href').split('?')[0]+'?mot-clef='+motClef;
            
            var params = [];            
            var paramsArray = setParamsDocuments(params, tri, url, motClef, typeDoc, fonds_concerne, date_de_parution, auteurs_doc);
            url = paramsArray[0];
            params = paramsArray[1];
            var link = getUrl(params);
            
            var data = {
                'action': 'loadDocuments',
                'mot-clef': motClef,
                'type': type,
                'type-de-doc': typeDoc,
                'fonds_concerne': fonds_concerne,
                'date_de_parution': date_de_parution,
                'auteurs_doc': auteurs_doc,
                'tri': tri,
                'paged': paged,
                'link': link
                },
                container = $('body main .section-results>.row');
                loadAjaxDocuments(data,container, url);
        });
        
        var paged=1;
        $(document).on('click','.loadmore',function(e){ 
            e.preventDefault();
            var data = {
                'action': 'loadDocuments',
                'mot-clef':$('form.filters input[name="mot-clef"]').val(),
                'type':$('form.filters input[name="type"]').val(),
                'type-de-doc':$('form.filters select[name="type-de-doc"]').val(),
                'fonds_concerne':$('form.filters select[name="fonds_concerne"]').val(),
                'date_de_parution':$('form.filters select[name="date_de_parution"]').val(),
                'auteurs_doc':$('form.filters select[name="auteurs_doc"]').val(),
                'tri':$('form.filters input[name="tri"]').val(),
                'paged': ++paged
                },
                button = $(this),
                container = $('body main .section-results>.row');
                
            $.ajax({
                url: ajaxurl,
                data: data, 
                type: 'GET',
                beforeSend: function ( xhr ) {
                    button.addClass('is-loading');
                    
                },
                success: function( data ){
                    if( data ) {
                        button.removeClass('is-loading');
                        data = $(data).find('.teaser');
                        if(data.length>0){
                            $('<div class="content" tabindex="-1">').insertAfter(container.find('.content').last());
                            container.find('.content').last().append(data);
                        }else{
                            button.remove();
                        }
                    } else {
                        button.remove();
                    }
                }
            });
        });
    }
    
    // UTILS
    function getUrl(params) {
        if (paged == null) {
            var paged = 1;
        } else {                
            paged = parseInt(paged);
        }
        var currentUrl = window.location.href;
        var cleanedUrl = currentUrl.split('?')[0].split('page/')[0];

        var urlParams = '';
        var i = 0;

        $(params).each(function(i, element) {
            if (element.value.length) {                    
                if (i == 0) {
                    urlParams += '?' + element.name + '=' + element.value;
                } else {
                    urlParams += '&' + element.name + '=' + element.value;
                }
            }

            ++i;
        });
        var completeUrl = cleanedUrl + urlParams;

        return completeUrl;
    }
});